import { render, staticRenderFns } from "./ResNormalRouter.vue?vue&type=template&id=c82db3bc&scoped=true&"
import script from "./ResNormalRouter.vue?vue&type=script&lang=js&"
export * from "./ResNormalRouter.vue?vue&type=script&lang=js&"
import style0 from "./ResNormalRouter.vue?vue&type=style&index=0&id=c82db3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82db3bc",
  null
  
)

export default component.exports